import React from 'react';
import { motion } from 'framer-motion';
import { SectionCard } from './SectionCard';
import { AppVersionLabel } from './AppVersionLabel';
import { cn } from '../../utils/cn';

/**
 * Centered auth card shell (login, forgot password, reset, change password).
 */
export function AuthPageShell({ className, children, title, description }) {
  return (
    <div
      className={cn(
        'flex min-h-screen items-center justify-center bg-slate-50 px-4 py-8 sm:p-6 md:p-8',
        className
      )}
    >
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: 'easeOut' }}
        className="w-full max-w-md"
      >
        <SectionCard className="border-slate-200/90 p-6 shadow-xl sm:p-8 md:p-10" padded={false}>
          {title ? (
            <h2 className="mb-1 text-xl font-black tracking-tight text-slate-900 sm:mb-2 sm:text-2xl md:text-3xl">
              {title}
            </h2>
          ) : null}
          {description ? (
            <p className="mb-6 text-sm font-medium text-slate-500 sm:mb-8">{description}</p>
          ) : null}
          {children}
          <div className="mt-6 border-t border-slate-100 pt-4">
            <AppVersionLabel align="center" />
          </div>
        </SectionCard>
      </motion.div>
    </div>
  );
}
